/**
 * E-Hentai source module. Auto-registered by `src/sources/registry.ts`.
 *
 * 99% of the implementation lives in `_eh-shared/`; this module is the
 * thin wrapper that picks the `SITE_E` context (host, api endpoint,
 * `nw=1` auto-append) and supplies e-hentai-specific copy.
 *
 * See `_eh-shared/README.md` for the full file map and architectural notes.
 */

import { buildEhSource } from '../_eh-shared/build-source';
import { SITE_E } from '../_eh-shared/urls';

const LOGIN_NOTES = `Recommended full login steps:

1. Open https://e-hentai.org/ in the same browser you will copy cookies from.
   Confirm you are signed in.

2. Open DevTools -> Application/Storage -> Cookies -> https://e-hentai.org.
   If you do not see the login cookies there, also check forums.e-hentai.org.

3. Copy these cookies into one Cookie line:

     Required for logged-in features:
       - ipb_member_id
       - ipb_pass_hash

     Strongly recommended if present:
       - cf_clearance    (Cloudflare proof for e-hentai.org)

     Optional if present:
       - __cf_bm         (Cloudflare bot-management state)
       - sk

   You do not need nw, event, or ipb_session_id.

4. Paste like this:

     ipb_member_id=...; ipb_pass_hash=...; cf_clearance=...; sk=...

5. Click Save. Bunko validates by contacting e-hentai through the proxy.
   If validation says the worker/proxy IP is temporarily blocked, tick
   "Save without validating" to store the cookies anyway, then retry browsing later.

Anonymous mode:
Tick "Browse anonymously" only if you are not using an account. Paste cf_clearance
from e-hentai.org, plus __cf_bm if your browser has it. Favorites stay disabled.`;

const source = buildEhSource({
  site: SITE_E,
  sourceId: 'ehentai',
  name: 'E-Hentai',
  description:
    'Browse, search, and read galleries from e-hentai.org. Login is optional (it unlocks 10-category favorites and your personal tag filters).',
  loginNotes: LOGIN_NOTES,
});

export default source;
